const DEBOUNCE_MS = 200;

// Admin product form: autocompletes the "Appellation" field (denomination)
// against HgesService::getProducingCountries() (see
// ProductController::appellations()) so it matches the controlled
// vocabulary HGES's own /rates and /hs-code endpoints expect, and fills the
// hidden manufacturingCountry field with the appellation's parent country
// code at the same time — see ProductType.
function initAppellationAutocompleteField(input) {
    const countryInput = input.closest('form')?.querySelector('[data-appellation-country]');
    const url = input.dataset.appellationUrl;
    if (!countryInput || !url) return;

    let suggestions = [];
    let loaded = false;
    let debounceHandle = null;

    const list = document.createElement('ul');
    list.className = 'appellation-autocomplete__list';
    list.hidden = true;
    input.insertAdjacentElement('afterend', list);
    input.setAttribute('autocomplete', 'off');

    async function ensureLoaded() {
        if (loaded) return;
        try {
            const response = await fetch(url, { headers: { Accept: 'application/json' } });
            suggestions = await response.json();
            loaded = true;
        } catch {
            suggestions = [];
        }
    }

    function render(query) {
        const normalized = query.trim().toLowerCase();
        const matches = normalized === ''
            ? []
            : suggestions.filter((s) => s.name.toLowerCase().includes(normalized)).slice(0, 20);

        list.innerHTML = '';
        matches.forEach((match) => {
            const item = document.createElement('li');
            item.className = 'appellation-autocomplete__item';
            item.textContent = match.name;
            item.addEventListener('mousedown', (event) => {
                // mousedown (not click) so this fires before the input's blur hides the list.
                event.preventDefault();
                input.value = match.name;
                countryInput.value = match.countryCode;
                list.hidden = true;
            });
            list.appendChild(item);
        });
        list.hidden = matches.length === 0;
    }

    input.addEventListener('input', () => {
        clearTimeout(debounceHandle);
        debounceHandle = setTimeout(async () => {
            await ensureLoaded();
            render(input.value);
        }, DEBOUNCE_MS);
    });

    input.addEventListener('blur', () => {
        setTimeout(() => { list.hidden = true; }, 100);
    });
}

function initAppellationAutocomplete() {
    document.querySelectorAll('[data-appellation-autocomplete]').forEach(initAppellationAutocompleteField);
}

export default initAppellationAutocomplete;
